import { bind, trigger } from '@confluence-classic/confluence-event_DO_NOT_USE';

import { requireLegacyWRM } from '@confluence/wrm/entry-points/requireLegacyWRMHelpers.ts';

const contexts = {};

const runSafely = (fn) => {
	try {
		fn();
	} catch (e) {
		// TODO: find a real fix for this issue HOT-82965 | CONFCLOUD-58951
		console.error(e);
	}
};

export const init = () => {
	requireLegacyWRM(
		['wrc!confluence-keyboard-shortcuts-batch'],
		() => {
			runSafely(() => {
				bind('register-contexts.keyboardshortcuts', (e, data) => {
					const { enableContext } = data.shortcutRegistry;
					Object.entries(contexts).forEach(([context, enabled]) => {
						if (enabled) {
							enableContext(context);
						}
					});
				});
				trigger('initialize.keyboardshortcuts');
			});
		},
		() => {
			if (process.env.NODE_ENV !== 'production') {
				console.error('Legacy keyboard shortcuts cannot be initialized when WRM is disabled.');
			}
		},
	);
};

export const rebind = () => {
	// We need to disable all shortcuts and enable again
	// the ones still available as the currrent library doesn't expose a
	// method for removing just one context and we want to keep previous
	// added contexts alive
	runSafely(() => {
		trigger('remove-bindings.keyboardshortcuts');
		trigger('initialize.keyboardshortcuts');
	});
};

const makeSetContext = (enable) => (newContexts) => {
	if (!Array.isArray(newContexts)) {
		newContexts = [newContexts];
	}

	newContexts.forEach((context) => {
		if (contexts[context] !== enable) {
			contexts[context] = enable;
			rebind();
		}
	});
};

export const enableContext = makeSetContext(true);

export const disableContext = makeSetContext(false);

export const teardown = () => {
	runSafely(() => {
		trigger('remove-bindings.keyboardshortcuts');
	});
};
